// import DataTable from "src/components/tables/presentation";

import { Badge, Label } from 'flowbite-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import CustomButton from 'src/components/common/custom-buttom';
import DataTable from 'src/components/tables';
import { AccessRight } from 'src/routes/PermissionEnum';
import { GenderOption, StatusOption } from 'src/utils/default-data';
import AddEditUser from './add-edit-user';

const MyUsers = () => {
  const [initialData, setInitialData] = useState<any>();
  const navigate = useNavigate()
  const renderUI = [
    {
      label: "Status",
      key: "status",
      type: "select",
      options: StatusOption
    },
    {
      label: "Gender",
      key: "gender",
      type: "select",
      options: GenderOption
    },
    {
      label: "Date Created",
      key: ["dateFrom", "dateTo"],
      type: "dateRange",
    },
    {
      label: "Active Users",
      key: ["activeFrom", "activeTo"],
      type: "dateRange",
    }

  ]

  const columns = [
    {
      header: 'Full Name',
      accessor: 'firstName',
      cell: (row: any) => (
        <Label
          onClick={() => {
            setInitialData(row)
          }}
          className="text-blue-600 cursor-pointer"
          value={`${row?.firstName} ${row?.lastName}`}
        />
      ),
    },
    { header: 'Email Address', accessor: 'emailAddress' },
    {
      header: 'Status', accessor: 'status', cell: (row) => (
        <Badge className={`${row.status == 'new' ? 'bg-blue-400' : row.status == 'active' ? 'bg-green-400' : 'bg-red-400'} rounded-lg`}>
          {row.status}
        </Badge>
      ),
    },
  ];

  return (
    <>
      <AddEditUser handleClose={setInitialData} initialData={initialData} />
      <DataTable
        heading="My Users"
        columns={columns}
        additionalUI={
          <CustomButton accessRight={AccessRight.ISEDIT} onClick={() => setInitialData(true)} size="xs">
            Add User
          </CustomButton>
        }
        config={{ url: 'users', key: ['users'] }}
      />
    </>
  );
};

export default MyUsers;
